import { render, staticRenderFns } from "./bMap.vue?vue&type=template&id=4bafcca0&"
import script from "./bMap.vue?vue&type=script&lang=js&"
export * from "./bMap.vue?vue&type=script&lang=js&"
import style0 from "./bMap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports